type CsvValue = string | number | boolean | null | undefined;

// Spreadsheets evaluate a cell starting with one of these as a formula; a leading quote keeps it text.
const FORMULA_PREFIX = /^[=+\-@\t\r]/;

const escapeCsvValue = (value: CsvValue): string => {
  if (value === null || value === undefined) {
    return '';
  }

  const text =
    typeof value === 'string' && FORMULA_PREFIX.test(value)
      ? `'${value}`
      : String(value);

  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

/** Header row from the keys of the first object, one line per object. */
export const toCsv = (rows: Record<string, CsvValue>[]): string => {
  if (rows.length === 0) {
    return '';
  }

  const headers = Object.keys(rows[0]);
  const lines = rows.map((row) =>
    headers.map((header) => escapeCsvValue(row[header])).join(',')
  );

  return [headers.join(','), ...lines].join('\r\n');
};

const BOM = '\uFEFF';

export const downloadCsv = (
  filename: string,
  rows: Record<string, CsvValue>[]
): void => {
  const blob = new Blob([`${BOM}${toCsv(rows)}`], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
